import React, { useContext } from "react";
import { Paper, Box, Button } from "@material-ui/core";
import {
  Sheet,
  SheetContent,
  LogoGGT,
  LogoGGV,
  PatientAuthByDob,
  IntroText
} from "../../components";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BrandThemeContext } from "../../contexts";
import { formatDate } from "../../utils";

const AppointmentAuth = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { appointment_id } = useParams();
  const { themeName } = useContext(BrandThemeContext);

  const handleOnSubmit = ({ dob = "" }) => {
    history.push(
      `/appointment/${appointment_id}/${formatDate(
        dob,
        "YYYY-MM-DD",
        "YYYYMMDD"
      )}`
    );
  };

  return (
    <Sheet data-cy="appointment-auth-view">
      <Box textAlign="center" pb={2}>
        {themeName === "GGT" && <LogoGGT />}
        {themeName === "GGV" && <LogoGGV />}
      </Box>
      <SheetContent>
        <Box mb={2}>
          <Paper>
            <Box p={2}>
              <IntroText>{t("appointment.auth.intro_text")}</IntroText>
              <PatientAuthByDob handleOnSubmit={handleOnSubmit}>
                <Button
                  type="submit"
                  fullWidth
                  color="primary"
                  variant="contained"
                  data-cy="button-submit-auth"
                >
                  {t("appointment.auth.button")}
                </Button>
              </PatientAuthByDob>
            </Box>
          </Paper>
        </Box>
      </SheetContent>
    </Sheet>
  );
};

export { AppointmentAuth };
